<script setup lang="ts">
const route = useRoute();
const localeRoute = useLocaleRoute();
const { user, loggedIn, refreshSession } = useAuth();

await callOnce("auth-session", () => refreshSession());

const showVerificationBanner = computed(
  () =>
    loggedIn.value &&
    !user.value?.emailVerified &&
    route.meta.layout !== "authorisation",
);
</script>

<template>
  <div class="h-full">
    <div
      v-if="showVerificationBanner"
      class="border-b border-primary-100 bg-primary-50 px-4 py-2.5 text-center text-sm text-app-text"
    >
      <span>{{ $t("verify_email_page.banner.text") }}</span>
      <NuxtLink
        :to="localeRoute('/verify-email')"
        class="ml-1 font-semibold text-primary hover:underline"
      >
        {{ $t("verify_email_page.banner.action") }}
      </NuxtLink>
    </div>

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <ToastContainer />
    <CookieConsent />
  </div>
</template>
